export default[
    {
        path: 'perExperience',
        name: 'PerExperience',
        component: () => import(/* webpackChunkName: "experienceManage" */ '@/views/person/experienceManage/index.vue'),
    },
];
